import { RuleObject } from 'antd/lib/form';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import i18n from '~/i18n';
import { basicValidation } from './basicValidation';

export type Validator = RuleObject['validator'];

const phoneValidation: Validator = basicValidation((rule, value, callback) => {
  try {
    // Add '+' prefix if missing and value starts with a digit
    let normalizedValue = value;
    if (value && !value.startsWith('+') && /^\d/.test(value)) {
      normalizedValue = `+${value}`;
    }

    const phoneNumber = parsePhoneNumberFromString(normalizedValue);
    if (!phoneNumber?.isPossible) {
      throw new Error(i18n.t('Impossible number', { ns: 'validation' }));
    }
    if (normalizedValue.length < 12) {
      throw new Error(i18n.t('Invalid number', { ns: 'validation' }));
    }
    callback();
  } catch (err) {
    console.log((err as any).message as string);
    callback((err as any).message as string);
  }
});

export default phoneValidation;
